import Vue from 'vue'
import App from '@/App.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from '@/router'
import store from '@/store'

import Video from 'video.js'
import 'video.js/dist/video-js.css'
import '@/assets/styles/style.css'

import {
    VueAxios
} from './utils/request'


import '@/assets/styles/app.scss';

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'


Vue.prototype.$video = Video;

Vue.config.productionTip = false;

Vue.use(VueAxios)
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);


router.beforeEach((to, from, next) => {
    const token = store.getters.token;
    const outerPaths = ['/pc/menu', '/pc/apply', '/pc/score', '/pc/upload', '/pc/userinfo'];
    let code = to.query ? to.query.code : null;
    if (code) {
        store.dispatch('threeLogin', code).then(data => {
            if (data.token) {
                next({
                    name: 'Teammenu',
                    query: {}
                });
            }else{
                next();
            }
        }).catch((err)=>{
            console.log(err,222)
            if (!token && outerPaths.includes(to.path)) {
                next('/pc/login');
            } else {
                next();
            }
        })
    }
    if (!token && outerPaths.includes(to.path)) {
        next('/pc/login');
    } else {
        next();
    }
});


new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app');